import script from "./driverInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./driverInfo.vue?vue&type=script&setup=true&lang=js"

import "./driverInfo.vue?vue&type=style&index=0&id=4ce57619&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ce57619"]])

export default __exports__